<div class="checkbox-group-header">
    <label
        nz-checkbox
        [(ngModel)]="allChecked"
        (ngModelChange)="updateAllChecked()"
        [nzIndeterminate]="indeterminate">
        {{ filterName }}
    </label>
    @if (displayValidationMessage) {
        <pf-text type="danger">{{ selectionRequiredMessage }}</pf-text>
    }
</div>
@if (!isGrouped) {
    <nz-checkbox-group
        data-pf-style="stacked"
        [nzOptions]="selectOptions()"
        [(ngModel)]="selected"
        (ngModelChange)="updateSingleChecked()"></nz-checkbox-group>
}
@if (isGrouped && searchEntityTypes) {
    @for (entityType of searchEntityTypes | keyvalue; track entityType.key) {
        @if (isEntityOptionsAvailable(entityType.key)) {
            <div class="entity-group">
                <nz-tag
                    [nzColor]="entityType.value.groupColor"
                    nzMode="closeable"
                    (nzOnClose)="entityGroupDelete(entityType.key)"
                    >{{ entityType.key }}
                </nz-tag>
                <nz-checkbox-group
                    [nzOptions]="selectEntityOptions[entityType.key]"
                    [(ngModel)]="selectedEntityValues[entityType.key]"
                    (ngModelChange)="
                        updateGroupChecked(entityType.key, $event)
                    "></nz-checkbox-group>
            </div>
        }
    }
}
@if (searchFacade || isGrouped) {
    <pf-select
        placeholder="Search.."
        [lazyLoad]="false"
        [control]="searchControl"
        (selected)="selectItem($event)"
        [clearAfterSelect]="true"
        [searchFacade]="searchFacade"
        [defaultQueryParams]="searchFilters"
        [grouped]="isGrouped"
        placement="topLeft"></pf-select>
}
